import $ = require('jquery');
import Modul from './Modul';

/**
 * Delicious module class
 */

export default class ModulDelicious extends Modul {
    constructor(moduleId: number) {
        super(moduleId);

        $("#b1_" + this.moduleId).diy_radiobox();
        $("#b2_" + this.moduleId).diy_radiobox();
        $("#s1_" + this.moduleId).diy_radiobox();
        $("#s2_" + this.moduleId).diy_radiobox();
        $("#s3_" + this.moduleId).diy_radiobox();

        let tagSeparatorInfoBox = $('.tag-separator-info-box', this.getEditorContainer());
        if (tagSeparatorInfoBox.length > 0) {
            let tagSepInfoText = tagSeparatorInfoBox.html();
            tagSeparatorInfoBox.html('');
            tagSeparatorInfoBox.quickhelp(tagSepInfoText, false, true, true);
        }
        this.form = this.getEditorContainer().find('form').diy_form({
            errorTarget: '.form-error'
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulDelicious.ts
 **/